import React from "react";
import ExploreSearch from "../../../Components/ExploreSearch/ExploreSearch";
import SelectDropdown from "../../../Components/DropDown/Select/SelectDropdown";
import { BsFilterLeft } from "react-icons/bs";
import { ExploreCard } from "./ExploreCard";

const Explore = () => {
  return (
    <>
      <div className="py-7 pl-4">
        {/* search */}
        <div className="shadow-[0px_5px_16px_rgba(0,0,0,0.06)] rounded-sm p-4">
          <h2 className="text-[30px] font-semibold">
            Find the best Career Counsellor!!
          </h2>
          <div className="flex justify-between w-full  items-center mt-4 ">
            <ExploreSearch />

            <div className="flex  items-center w-[30%] ml-5">
              <div className="flex  items-center w-fit">
                <BsFilterLeft className=" text-[30px]" />

                <p className="w-[100px]">Sort By</p>
              </div>
              <SelectDropdown />
            </div>
          </div>
        </div>
        {/* explore card */}

        <div>
          <div className="mx-auto max-w-7xl  lg:px-0">
            <div className="mt-8 flex justify-between  items-center flex-wrap">
              {Array.from({ length: 9 }).map((_, i) => (
                <ExploreCard key={i} isAdCard={i === 4} cardIndex={i} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Explore;
